import type { PendingAwaitingInput } from "@/api/awaiting-input";
import type { AgentCursorQuestion, AwaitingInput } from "@/stores/canvas-store";
import { desktopApprovalFields } from "@/lib/desktop-approval-question";

interface PendingAwaitingInputHydrationActions {
  addAwaitingInput: (awaiting: AwaitingInput) => void;
  setAgentCursorQuestion: (
    agentId: string,
    question: AgentCursorQuestion,
    fallback: { spaceId: string; name: string; color: string },
  ) => void;
}

export function hydratePendingAwaitingInputs(
  pendingInputs: PendingAwaitingInput[],
  spaceId: string,
  actions: PendingAwaitingInputHydrationActions,
): void {
  for (const input of pendingInputs) {
    if (input.frame) {
      actions.addAwaitingInput({
        id: input.id,
        frameId: input.frame,
        executionId: input.execution,
        projectId: spaceId,
        conversationId: input.conversation_id ?? null,
        taskId: input.task_id ?? null,
        question: input.question,
        context: input.context,
        options: input.options,
        createdAt: input.created_at,
        timeoutAt: input.timeout_at,
      });
    }

    // Live requests always render on the cursor as well as the optional
    // legacy frame bar. Reloading must reconstruct that same dual surface.
    if (input.agent_id) {
      actions.setAgentCursorQuestion(
        input.agent_id,
        {
          awaitingInputId: input.id,
          question: input.question,
          options: input.options ?? [],
          ...desktopApprovalFields(input),
        },
        {
          spaceId,
          name: input.name ?? input.agent_key ?? "agent",
          color: input.color ?? "var(--color-accent)",
        },
      );
    }
  }
}
